import { render } from "./SecurityPolicyMessageView.vue?vue&type=template&id=e9612c9c"
import script from "./SecurityPolicyMessageView.vue?vue&type=script&lang=js"
export * from "./SecurityPolicyMessageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__